import React, {useState} from 'react'

import {Button} from '../../../components/UI/index.js'
import {formSpacing, FormStack, Input} from '../../../components/UI/forms/index.js'
import {StatusBanner, StepTitle} from './ui.js'

export default function SearchForm({color, initialSearch, loading, error, onSearch}) {
    const [orderNumberOrTrackTrace, setOrderNumberOrTrackTrace] = useState(initialSearch.orderNumberOrTrackTrace)
    const [postalCode, setPostalCode] = useState(initialSearch.postalCode)

    const canSearch = orderNumberOrTrackTrace.trim() && postalCode.trim()

    const onSubmit = (event) => {
        event.preventDefault()

        if (canSearch) {
            onSearch({orderNumberOrTrackTrace: orderNumberOrTrackTrace.trim(), postalCode: postalCode.trim()})
        }
    }

    return (
        <form className='rp-fade-in' onSubmit={onSubmit}>
            <StepTitle
                title='Retour aanmelden'
                subtitle='Vul je ordernummer of Track & Trace code en je postcode in om je bestelling te vinden.'
            />

            {error && <StatusBanner tone='error'>{error}</StatusBanner>}

            <FormStack style={{marginBottom: formSpacing.rowGap}}>
                <Input
                    label='Ordernummer of Track & Trace code'
                    value={orderNumberOrTrackTrace}
                    onChange={(event) => setOrderNumberOrTrackTrace(event.target.value)}
                />

                <Input
                    label='Postcode'
                    value={postalCode}
                    onChange={(event) => setPostalCode(event.target.value.toUpperCase())}
                />
            </FormStack>

            <Button
                type='submit'
                variant='solid'
                color={color}
                style={{width: '100%', marginTop: 16}}
                loading={loading}
                disabled={!canSearch}
                label='Zoek mijn bestelling'
            />
        </form>
    )
}
